/**
 * 个人信息
 */
export function getpeopleinfo() {

    return [
        {
            name: "考生号",
            type: "text",
            value: "",
            key: "stuNum",
            disabled: true,
        },{
            name: "姓名",
            type: "text",
            value: "",
            disabled: true,
            key: "name",
        }, {
            name: "性别",
            type: "text",
            value: "",
            key: "sex",
            disabled: true,
        }, 
        {
            name: "科类",
            type: "text",
            value: "",
            key: "studyType",
            disabled: true,
        },
         {
            name: "身份证号",
            type: "text",
            value: "",
            key: "idCard",
            disabled: true,
        }, 
        {
            name: "投档段类	",
            type: "text",
            value: "",
            key: "portfolioCategory",
            disabled: true,
        }, {
            name: "考试志愿",
            type: "text",
            value: "",
            key: "readyProfession",
            disabled: true,
        }, 
        {
            name: "志愿类别",
            type: "text",
            value: "",
            key: "volunteerType",
            disabled: true,
        },{
            name: "毕业院校",
            type: "text",
            value: "",
            key: "school",
            disabled: true,
        },{
            name: "毕业专业",
            type: "text",
            value: "",
            key: "profession",
            disabled: true,
        },
        {
            name: "联系电话",
            type: "text",
            value: "",
            key: "phone",
            disabled: true,
        },
        {
            name: "紧急联系人",
            type: "text",
            value: "",
            key: "contact",
            disabled: true,
        },
        {
            name: "家庭住址",
            type: "text",
            value: "",
            key: "address",
            disabled: true,
        },
        //  {
        //     name: "学籍资料审核表",
        //     // type: "icon",
        //     type: "fileOrIcon",
        //     value: [],
        //     key: "statusCheckFile",
        //     disabled: true,
        // },
        // {
        //     name: "免试（加分）",
        //     // type: "icon",
        //     type: "fileOrIcon",
        //     value: [],
        //     key: "withoutTestFile",
        // },
        {
            name: "报名材料",
            // type: "icon",
            type: "fileOrIcon",
            value: [],
            key: "proveFile",
        },
        // {},
        {
            name: "审核结果",
            type: "select",
            value: "",
            options: [{
                label: '通过',
                value: "2"
            }, {
                label: '不通过',
                value: "3"
            }],
            key: "status",
        },
        {
            name: "不通过原因",
            type: "state",
            value: '',
            restaurants: [],
            key: "refuseReason",
        },

    ]
}


export function getSearchData(configList) {
    return [
        { name: "姓名/专业", type: "input-search", value: "", key: "name" },
        { name: "学校", type: "select", value: "", key: "school", options: configList.schoolList },
        { name: "报考专业", type: "select", value: "", key: "readyProfession", options: configList.professionList },
        {
            name: "鼓励政策",
            type: "select",
            value: "",
            key: "specialFlag",
            options: [
                { label: "非鼓励政策", value: "非鼓励政策" },
                { label: "鼓励政策（免试或面试）", value: "免试" },
                { label: "鼓励政策（加分）", value: "加分" },
            ]
        },
    ]
}

/**
 * 获取标签设置的表格表头
 */
export function getAttributeMenu() {
    return [
        { key: "stuNum", name: "考生号", sortable: false, width: 110, },
        { key: "name", name: "姓名", sortable: false, width: 90, },
        { key: "sex", name: "性别", sortable: false, width: 60, },
        { key: "volunteerType", name: "志愿类别", sortable: false, width: 120 },
        { key: "readyProfession", name: "考生志愿", sortable: false, width: 200 },
        { key: "school", name: "毕业院校", sortable: false, width: 200, },
        { key: "profession", name: "毕业专业", sortable: false, width: 200, },
        { key: "phone", name: "联系电话", sortable: false, width: 120, },
        { key: "contact", name: "紧急联系人", sortable: false, width: 120, },
        // { key: "stuStatusNum", name: "中职学籍号", sortable: false, width: 100 },
        // { key: "nation", name: "民族", sortable: false, width: 110, },
        // { key: "political", name: "政治面貌", sortable: false, width: 110, },
        { key: "idCard", name: "身份证号", sortable: false, width: 100 },
        { key: "address", name: "家庭住址", sortable: false, },


        // { key: "applyTime", name: "报名时间", width: 120, sortable: true },
        // { key: "stuStatusNum", name: "中职学籍", width: 120, sortable: false },
        // { key: "profession", name: "专业", sortable: false },
        // { key: "nation", name: "民族", sortable: false },
        // { key: "idCard", name: "身份证", width: 220, sortable: false },
        // { key: "political", name: "政治面貌", sortable: false },


    ]
}
